import axios from "axios";
import { toast } from "react-toastify";

const baseURL = process.env.REACT_APP_PORT || "/";

export const api = axios.create({ baseURL, withCredentials: true });

const attachAuth = (config) => {
  // The auth cookie travels automatically when withCredentials is set.
  // For the Magic OTP /login step, the client sends the DID via the
  // Authorization header — preserve it.
  if (config.url && /\/?login\/?$/.test(config.url)) return config;
  return config;
};

const handleAuthFailures = (err) => {
  const status = err?.response?.status;
  const url = err?.config?.url || "";
  // Silent probes — /me is used to check whether a cookie session exists
  // on bootstrap, so a 401 there is expected and should not nag the user.
  const silent = /\/?me$/.test(url);

  if (status === 401) {
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("isLoggedIn");
    if (!silent && window.location.pathname !== "/") {
      toast.error("Session expired. Please log in again.");
      setTimeout(() => window.location.assign("/"), 600);
    }
  } else if (status === 403 && !silent) {
    toast.error("You don't have permission to do that.");
  }
  return Promise.reject(err);
};

api.interceptors.request.use(attachAuth);
api.interceptors.response.use((r) => r, handleAuthFailures);

// Global axios — covers existing pages that call axios directly. The cookie
// only travels if withCredentials is set on each request, so we force it here.
axios.defaults.withCredentials = true;
axios.interceptors.request.use(attachAuth);
axios.interceptors.response.use((r) => r, handleAuthFailures);

export default api;
